'use strict';

var core = angular.module('core', [
    'md.data.table',
    'ngClipboard',
    'ui.router',
    'ui',
    'angular-loading-bar',
    'ngFileUpload', 'angularStats',
    'pascalprecht.translate',
    'ngMaterial',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ngAnimate',
    'ngMessages',
    'dndLists',
    'esCommons',
    'angularResizable',
    'esForm',
    'angular-google-analytics',
    'highcharts-ng',
    'meedy'
]);

core.config(['$locationProvider', '$httpProvider', '$translateProvider', 'cfpLoadingBarProvider', 'ngClipProvider', '$mdIconProvider', '$mdThemingProvider', '$mdDateLocaleProvider', '$injector', 'AnalyticsProvider',
    function ($locationProvider, $httpProvider, $translateProvider, cfpLoadingBarProvider, ngClipProvider, $mdIconProvider, $mdThemingProvider, $mdDateLocaleProvider, $injector, AnalyticsProvider) {

        // this is for cross domain cookies
        $httpProvider.defaults.withCredentials = true;

        $locationProvider.html5Mode(false);
        $locationProvider.hashPrefix('!');

        $mdThemingProvider.theme('default')
            .primaryPalette('indigo')
            .accentPalette('light-blue');

        moment.locale('pl');

        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'L', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
        $mdDateLocaleProvider.formatDate = function(date) {
            if(date) {
                return moment(date).format('L');
            }
            return '';
        };
        $mdDateLocaleProvider.firstDayOfWeek = 1;

        $httpProvider.interceptors.push('loadingInterceptor', /*'authInterceptor', 'errorInterceptor',*/ 'responseInterceptor');

        if($injector.has('meedyConstant')) {
            for(var i = 0; i < $injector.get('meedyConstant').interceptors.length; i++) {
                $httpProvider.interceptors.push($injector.get('meedyConstant').interceptors[i]);
            }
        } else if($injector.has('edmConstant')) {
            for(var i = 0; i < $injector.get('edmConstant').interceptors.length; i++) {
                $httpProvider.interceptors.push($injector.get('edmConstant').interceptors[i]);
            }
        }

        var files = [];

        if($injector.has('meedyConstant')) {
            files.push.apply(files, $injector.get('meedyConstant').files);
        }
        if($injector.has('edmConstant')) {
            files.push.apply(files, $injector.get('edmConstant').files);
        }

        var coreTranslations = [
            { prefix: './core/resource/locale/', suffix: '/application.json' }
        ];

        files = files.concat(coreTranslations);

        $translateProvider.useStaticFilesLoader({
            files: files
        });
        $translateProvider.registerAvailableLanguageKeys(['pl_PL'], {
            'en': 'en_US',
            'EN': 'en_US',
            'gb': 'en_US',
            'GB': 'en_US',
            'en_us': 'en_US',
            'en_UK': 'en_US',
            'en_uk': 'en_US',
            'en_GB': 'en_US',
            'en_gb': 'en_US',
            'pl': 'pl_PL',
            'PL': 'pl_PL',
            'de': 'de_DE',
            'DE': 'de_DE',
            'de_DE': 'de_DE'
        });

        $translateProvider.usePostCompiling(true);
        $translateProvider.fallbackLanguage('pl_PL');
        $translateProvider.preferredLanguage('pl_PL');

        cfpLoadingBarProvider.includeSpinner = true;
        cfpLoadingBarProvider.includeBar = true;
        cfpLoadingBarProvider.latencyThreshold = 100;

        ngClipProvider.setPath('lib/zeroclipboard/ZeroClipboard.swf');

        if($injector.has('config') || $injector.has('meedyConfig') ) {

            var config = $injector.has('meedyConfig') ? $injector.get('meedyConfig') : null;
            config = config == null && $injector.has('config') ? $injector.get('config') : config;

            if(config && config.ANALYTICS) {

                AnalyticsProvider.setAccount({
                    tracker: config.ANALYTICS_CODE,
                    name: "portalTracker",
                    crossDomainLinker: true,
                    displayFeatures: true,
                    enhancedLinkAttribution: true,
                    select: function (args) {
                        // This function is used to qualify or disqualify an account object to be run with commands.
                        // If the function does not exist, is not a function, or returns true then the account object will qualify.
                        // If the function exists and returns false then the account object will be disqualified.
                        // The 'args' parameter is the set of arguments (which contains the command name) that will be sent to Universal Analytics.
                        return true;
                    },
                    //set: {
                    //    forceSSL: true
                    //    // This is any set of `set` commands to make for the account immediately after the `create` command for the account.
                    //    // The property key is the command and the property value is passed in as the argument, _e.g._, `ga('set', 'forceSSL', true)`.
                    //    // Order of commands is not guaranteed as it is dependent on the implementation of the `for (property in object)` iterator.
                    //},
                    trackEvent: true,
                    trackEcommerce: true
                });
                AnalyticsProvider.enterDebugMode(config.DEV_MODE);
            }
        }
	}
]);

core.run(['$rootScope', '$log', '$templateCache', '$injector',
    function($rootScope, $log, $templateCache, $injector) {

        var config = {};
        if($injector.has('meedyConfig')) {
            config = $injector.get('meedyConfig');
        } else if($injector.has('edmConstant')) {
            config = $injector.get('config');
        } else {
            config = $injector.get('coreConfig');
        }

        if (config.DEV_MODE) {
            $log.info('---------------------------------------------------------------------------');
            $log.info('Application "' + config.APPLICATION_CUSTOMER + ' ' + config.APPLICATION_NAME + '" initialized.');
            $log.info('---------------------------------------------------------------------------');
            $log.info('Client Version: ' + config.VERSION);
            // $log.info(' AUTH Endpoint: ' + config.AUTH_URL);
            $log.info('  API Endpoint: ' + config.API_URL);
            $log.info('---------------------------------------------------------------------------');
        }


        // this is pagination template for md-data-table.
        $templateCache.put('templates.md-data-table-pagination.html',
            '<div>\n' +
            '  <span class="label">{{paginationLabel.text}}</span>\n' +
            '  <md-select ng-model="limit" md-container-class="md-pagination-select" ng-change="onSelect()" aria-label="Row Count" placeholder="{{rowSelect ? rowSelect[0] : 5}}">\n' +
            '    <md-option ng-repeat="rows in rowSelect ? rowSelect : [5, 10, 15]" ng-value="rows">{{rows}}</md-option>\n' +
            '  </md-select>\n' +
            '  <span ng-if="total == 0">{{page}} {{paginationLabel.of}} 1</span>\n' +
            '  <span ng-if="total > 0">{{page}} {{paginationLabel.of}} {{total/limit}}</span>\n' +
            '</div>\n' +
            '<div>\n' +
            '  <md-button type="button" ng-click="first()" ng-disabled="!hasPrevious()" aria-label="First">\n' +
            '    <md-icon md-svg-icon="templates.navigate-first.html"></md-icon>\n' +
            '  </md-button>\n' +
            '  <md-button type="button" ng-click="previous()" ng-disabled="!hasPrevious()" aria-label="Previous">\n' +
            '    <md-icon md-svg-icon="templates.navigate-before.html"></md-icon>\n' +
            '  </md-button>\n' +
            '  <md-button type="button" ng-click="next()" ng-disabled="!hasNext()" aria-label="Next">\n' +
            '    <md-icon md-svg-icon="templates.navigate-next.html"></md-icon>\n' +
            '  </md-button>\n' +
            '  <md-button type="button" ng-click="last()" ng-disabled="!hasNext()" aria-label="Last">\n' +
            '    <md-icon md-svg-icon="templates.navigate-last.html"></md-icon>\n' +
            '  </md-button>\n' +
            '</div>\n' +
            '');
    }
]);

angular.element(document).ready(function() {
    angular.bootstrap(document, ['core'], {
        strictDi: true
    });
});

jQuery.extend(jQuery.expr[':'], {
    focus: "a == document.activeElement"
});

if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function(suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}